import { lazy, Suspense, useEffect } from 'react';


import Index from "./jsx";
import { connect, useDispatch, useSelector } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';

import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';

import 'bootstrap-select/dist/css/bootstrap-select.min.css';
import "./css/style.css";
import 'react-quill/dist/quill.snow.css';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';


const SignUp = lazy(() => import('./jsx/pages/Registration'));
const ForgotPassword = lazy(() => import('./jsx/pages/ForgotPassword'));
const OtpVerify = lazy(() => import('./jsx/pages/OtpVerify'));

const Login = lazy(() => {
  return new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  });
});

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }
  return ComponentWithRouterProp;
}


function App(props) {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    checkAutoLogin(dispatch, navigate);
  }, []);

  let routeblog = (
    <>
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/otp-verify' element={<OtpVerify />} />
        <Route path='/page-register' element={<SignUp />} />
        <Route path='/page-forgot-password' element={<ForgotPassword />} />
      </Routes>
    </>
  );

  const authState = useSelector((state) => state.auth);
  const location = useLocation();
  



const isOtpVerified = authState.auth?.isOtpVerified === true;




if (props.isAuthenticated && !isOtpVerified) {
  return <Navigate to="/otp-verify" replace />;
}


if (props.isAuthenticated && isOtpVerified) {
 
  return (
    <>
      <Suspense fallback={
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      }>
        <Index />
      </Suspense>
      <ToastContainer />
    </>
  );
}







  else {
    return (
      <div className="vh-100">
        <Suspense fallback={
          <div id="preloader">
            <div className="sk-three-bounce">
              <div className="sk-child sk-bounce1"></div>
              <div className="sk-child sk-bounce2"></div>
              <div className="sk-child sk-bounce3"></div>
            </div>
          </div>
        }
        >
          {routeblog}
        </Suspense>
        <ToastContainer />
      </div>
    );
  }
};


const mapStateToProps = (state) => {
 
  return {
    isAuthenticated: isAuthenticated(state),
  };
};


export default withRouter(connect(mapStateToProps)(App)); 